import { Token } from "./types";

export const WETH = {
  97: new Token(97, '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd', 18, 'WBNB', 'Wrapper BNB'),
  56: new Token(56, '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', 18, 'WBNB', 'Wrapper BNB'),
}

export const TOKEN_LIST = {
  97: [
    WETH[97],
  ],
  56: [
    new Token(56, '0x8d39785865CcA3b4B331C9509A72d44B33333333', 18, 'W3', 'W3'),
    WETH[56],
    new Token(56, '0x55d398326f99059fF775485246999027B3197955', 18, 'USDT', 'Tether USD'),
    new Token(56, '0xea6aa3a039f442f572a5bf31c63ad7ad89a7ffff', 18, '4Burn', '4Burn'),
    new Token(56, '0x4619e5932ee96b317808e15d53824b97b6b94444', 18, 'Xone', 'Xone')
  ]
}

export const SUGGESTED_BASES = {
  97: [
    WETH[97],
  ],
  56: [
    WETH[56],
    new Token(56, '0x55d398326f99059fF775485246999027B3197955', 18, 'USDT', 'Tether USD'),
    new Token(56, '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d', 18, 'USDC', 'USD Coin'),
    new Token(56, '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56', 18, 'BUSD', 'BUSD Token'),
    new Token(56, '0x2170Ed0880ac9A755fd29B2688956BD959F933F8', 18, 'ETH', 'Ethereum Token'),
    new Token(56, '0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d', 18, 'USD1', 'USD1'),
    new Token(56, '0xC9882dEF23bc42D53895b8361D0b1EDC7570Bc6A', 6, 'FIST', 'FistToken'),
    new Token(56, '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c', 6, 'BTCB', 'BTCB Token'),
  ],
}
